﻿export class MyQuestion {
    id: number;
    dateQuestionFormatted: string;
    dateAnswerFormatted: string;
    questionUser: string;
    question: string;
    answer: string;
    activeQuestion: boolean;
    activeAnswer: boolean;
    answerUser: string;
    isBlocked: boolean;
    inputAnswerName: string;
    inputAnswerId: number;
}